export default __webpack_public_path__ + "static/media/tecnologia.706534f4.png";